export enum Breakpoints {
  ThinMobile = 'ThinMobile',
  Mobile = 'Mobile',
  TabletPortrait = 'TabletPortrait',
  TabletLandscape = 'TabletLandscape',
  Desktop = 'Desktop',
  WideDesktop = 'WideDesktop',
  UltraWideDesktop = 'UltraWideDesktop',
}

export type BreakpointsType = `${Breakpoints}`;

export const BreakpointsValues: Record<BreakpointsType, number> = {
  [Breakpoints.ThinMobile]: 360,
  [Breakpoints.Mobile]: 414,
  [Breakpoints.TabletPortrait]: 768,
  [Breakpoints.TabletLandscape]: 1024,
  [Breakpoints.Desktop]: 1920,
  [Breakpoints.WideDesktop]: 2560,
  [Breakpoints.UltraWideDesktop]: Number.MAX_SAFE_INTEGER,
};

export const breakpointsArray = Object.entries(BreakpointsValues) as [
  BreakpointsType,
  number
][];
